import { render, staticRenderFns } from "./login-dialog.vue?vue&type=template&id=63d10c0e&scoped=true&"
import script from "./login-dialog.vue?vue&type=script&lang=js&"
export * from "./login-dialog.vue?vue&type=script&lang=js&"
import style0 from "./login-dialog.vue?vue&type=style&index=0&id=63d10c0e&prod&scoped=true&lang=css&"
import style1 from "./login-dialog.vue?vue&type=style&index=1&id=63d10c0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d10c0e",
  null
  
)

export default component.exports